import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex((current) => (current === idx ? null : idx));
  };

  return (
    <section id="faq" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-4xl">
        <SectionHeading
          eyebrow="常见问题"
          title="你可能想先弄清楚的问题"
          desc="把浏览时最常遇到的疑问集中在这里，点开即可查看，不需要来回跳转。"
          align="center"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((item, idx) => {
            const open = openIndex === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => toggle(idx)}
                    aria-expanded={open}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-primary-600 transition-transform ${
                        open ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                </h3>
                {open ? (
                  <div className="animate-fade-in border-t border-background-200 px-5 pb-5 pt-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}